import { GetTripResponse } from '../../services';
import { logger } from '../logger';
import { isDateDefined } from '../trips';
import { isAfter } from 'date-fns';

export function hasTripOccurred(
  trip: GetTripResponse,
  dateToCompare: Date = new Date()
) {
  if (!isDateDefined(trip.pickUpDateTime)) {
    logger.warn(
      'hasTripOccurred: trip is missing a pickup date, treating as not occurred'
    );
    return false;
  }

  if (isAfter(new Date(trip.pickUpDateTime), dateToCompare)) {
    return false;
  }

  return [
    'CANCELLED',
    'COMPLETED',
    'NO_SHOW',
    'NO_SHOW_COMPLETED',
    'LATE_CANCEL',
  ].includes(trip.tripStatus ?? '');
}
